import { MultiSelect } from "react-multi-select-component";
import './MultiSelect.css';

const InputMultiSelect = ({...props}) => {
    return ( 
        <MultiSelect
           {...props}
            hasSelectAll={false}
            disableSearch
            overrideStrings={{
                selectSomeItems: "Seleccione...",
                allItemsAreSelected: "Todos los elementos están seleccionados",
                selectAll: "Seleccionar todo",
                search: "Buscar",
              }}
              labelledBy="Seleccione"
        />
     );
}

export default InputMultiSelect;